<app-navbar-style-one></app-navbar-style-one>

<div class="home-slider owl-carousel owl-theme">
    <div class="slider-item" 
        style="background-image: url('../../../assets/img/home2/order-online.jpg');">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Check-out</h1>
                        <p>"Craving wings or sandwiches? Order online and we'll have it hot and ready!"</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid py-5">
  <div class="row">
    <!-- Left Column -->
    <div class="col-lg-7">
        <div class="card mb-4">
            <div class="card-body">
                <h2 class="card-title mb-4">Information Details</h2>
                <form [formGroup]="informationDetailsForm" (ngSubmit)="saveAddress()">
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <label class="form-label">Full Name<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" [readonly]="!guestMode" placeholder="Enter full name" name="fullname" formControlName="fullname">
                            <div *ngIf="informationDetailsForm.get('fullname')?.invalid && informationDetailsForm.get('fullname')?.touched" 
                                class="text-danger small mt-1">
                                Full name is required
                            </div>
                        </div>
                        <div class="col-lg-6 mb-3">
                            <label class="form-label">Phone Number<span class="text-danger">*</span></label>
                            <input type="tel" class="form-control" [readonly]="!guestMode" placeholder="Enter phone number" [(ngModel)]="phoneNumber" name="phoneNumber" formControlName="phoneNumber"> <!--(input)="formatPhoneInput($event)"-->
                            <div *ngIf="informationDetailsForm.get('phoneNumber')?.invalid && informationDetailsForm.get('phoneNumber')?.touched" 
                                class="text-danger small mt-1">
                                Valid phone number is required
                            </div>
                            <div *ngIf="informationDetailsForm.get('phoneNumber')?.pattern && informationDetailsForm.get('phoneNumber')?.touched" 
                                class="text-danger small mt-1">
                                Valid phone number is required
                            </div>
                        </div>
                        <div class="col-lg-6 mb-3">
                            <label class="form-label">Email Address<span class="text-danger">*</span></label>
                            <input type="email" class="form-control" [readonly]="!guestMode" placeholder="Enter email" name="email" formControlName="email">
                            <div *ngIf="informationDetailsForm.get('email')?.invalid && informationDetailsForm.get('email')?.touched" 
                                class="text-danger small mt-1">
                                Valid email is required
                            </div>
                        </div>
                        <div class="col-lg-12 mb-3">
                            <label class="form-label">Note (Optional)</label>
                            <textarea rows="5" class="form-control" [(ngModel)]="note" placeholder="Enter your notes" name="note" formControlName="note"></textarea>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="card oldAddress mb-4" *ngIf="deliveyOption != 'pickup'">
            <div class="card-body">
                <h2 class="card-title mb-4">Address</h2>
                <!-- Loading State -->
                <div class="account-card text-center" *ngIf="isLoading">
                    <div class="spinner-grow" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
                <!-- Addresses List -->
                <div class="row" *ngIf="allAddresses && allAddresses.length > 0 && !guestMode">
                    <div class="col-lg-12 col-md-12 mb-4" *ngFor="let address of allAddresses">
                        <div class="card h-100" [class.border-primary]="address.isMain">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-start">
                                    <h5 class="card-title">{{address.city}}</h5>
                                    <span *ngIf="address.isMain" class="badge bg-primary">Main</span>
                                </div>
                                <p class="card-text">{{address.address}}</p>
                            </div>
                            <div class="card-footer bg-transparent">
                                <!-- <button class="btn btn-sm btn-outline-primary me-2" (click)="editAddress(address)">
                                    <i class="bx bx-edit"></i> Edit
                                </button> -->
                                <button class="btn btn-sm btn-outline-danger me-2" (click)="deleteAddress(address.id)" 
                                        *ngIf="!address.isMain" [disabled]="isLoading">
                                    <i class="bx bx-trash"></i> Delete
                                </button>
                                <button class="btn btn-sm" 
                                        [class.btn-primary]="!address.isMain"
                                        [class.btn-success]="address.isMain"
                                        (click)="setAsMain(address.id)" 
                                        [disabled]="isLoading || address.isMain">
                                    <i class="bx" [class.bx-check]="address.isMain" [class.bx-star]="!address.isMain"></i>
                                    {{ address.isMain ? 'Main Address' : 'Set as Main' }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-end">
                        <button class="btn btn-primary" id="AddNewAddress" (click)="addNewAddress()">
                            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                            Add New Address
                        </button>
                    </div>
                </div>

                <form class="d-none" id="addressForm" [formGroup]="addressForm" (ngSubmit)="submitAddress()">
                    <div class="row">
                    <!-- Country Dropdown -->
                        <div class="col-md-12 mb-3">
                            <label class="form-label">Country <span class="text-danger">*</span></label>
                            <select class="form-control w-100" formControlName="country_id" (change)="onCountryChange($event.target)">
                                <option value="" disabled selected>Select Country</option>
                                <option *ngFor="let country of allCountries" [value]="country.id">
                                    {{ country.name }}
                                </option>
                            </select>
                            <!-- {{ allCountries[0].name }} -->
                            <div *ngIf="addressForm.get('country_id')?.hasError('required') && addressForm.get('country_id')?.touched" 
                                class="text-danger small mt-1">
                                Country is required
                            </div>
                        </div>

                        <!-- City Dropdown -->
                        <div class="col-md-12 mb-3" >
                            <label class="form-label">City <span class="text-danger">*</span></label>
                            <select class="form-control w-100" formControlName="city_id">
                                <option value="" disabled selected>Select City</option>
                                <option *ngFor="let city of cities" [value]="city.id">
                                    {{ city.name }}
                                </option>
                            </select>
                            <div *ngIf="addressForm.get('city_id')?.hasError('required') && addressForm.get('city_id')?.touched" 
                                class="text-danger small mt-1">
                                City is required
                            </div>
                        </div>

                        <!-- Address with Autocomplete -->
                        <div class="col-12 mb-3">
                            <label class="form-label">Address <span class="text-danger">*</span></label>
                            <input type="text" id="addressInput1" formControlName="address" 
                                class="form-control" placeholder="Start typing your address...">
                            <div *ngIf="addressForm.get('address')?.hasError('required') && addressForm.get('address')?.touched" 
                                class="text-danger small mt-1">
                            Address is required
                            </div>
                        </div>

                        <!-- Building, Floor, Flat -->
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Building </label>
                            <input type="text" class="form-control" formControlName="building" placeholder="Building no.">
                        </div>

                        <div class="col-md-4 mb-3">
                            <label class="form-label">Floor </label>
                            <input type="text" class="form-control" formControlName="floor" placeholder="Floor no.">
                        </div>

                        <div class="col-md-4 mb-3">
                            <label class="form-label">Flat </label>
                            <input type="text" class="form-control" formControlName="flat" placeholder="Flat no.">
                        </div>

                        <!-- Special Mark -->
                        <div class="col-12 mb-3">
                            <label class="form-label">Special Mark </label>
                            <textarea class="form-control" formControlName="special_mark" 
                                    placeholder="Any special landmarks or directions"></textarea>
                        </div>

                        <!-- Submit Button -->
                        <div class="col-12 text-center" *ngIf="!guestMode">
                            <button class="btn btn-primary" type="submit" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                Save Address
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <!-- <div class="card mb-4" *ngIf="paymentMethod == 'card' || paymentMethod == 'Card'">
            <div class="card-body">
                <h2 class="card-title mb-4">Payment method</h2>            
                <div class="p-5 mb-3 text-center">
                    <img src="../../../../assets/img/home2/card.png" width="320" class="img-fluid m-auto" alt="Card">
                </div>
                <form class="card-details" >
                    <div class="mb-3">
                        <label class="form-label">Name on card <span class="text-danger">*</span></label>
                        <div class="customField">
                            <input type="text" [(ngModel)]="paymentData.cardHolderName" name="cardHolderName" 
                                class="form-control" placeholder="Esther Howard" required>
                            <i class="bx bx-user"></i>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Billing Address Card <span class="text-danger">*</span></label>
                        <div class="customField">
                            <input type="text" [(ngModel)]="paymentData.billingAddress" name="billingAddress" 
                                    class="form-control" id="billingAddress" (input)="showAddress($event)"
                                    placeholder="Billing Address" required>
                            <i class="bx bx-map"></i>
                        </div>
                        <small style="color: green;font-size: 12px;">This is the address where your card will be charged</small>
                    </div>
                
                    <div class="mb-3">
                        <label class="form-label">Card number <span class="text-danger">*</span></label>
                        <div class="customField">
                            <input type="text" [(ngModel)]="paymentData.cardNumber" name="cardNumber" 
                                    (input)="formatCardNumber($event)" class="form-control" 
                                    placeholder="1234-5678-9012-3456" maxlength="19" required>
                            <i class="bx bx-credit-card"></i>
                        </div>
                    </div>
                
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Expiry date <span class="text-danger">*</span></label>
                            <div class="customField">
                                <input type="text" [(ngModel)]="paymentData.expirationDate" name="expirationDate" 
                                    (input)="formatExpiryDate($event)" class="form-control" 
                                    placeholder="MM/YY" maxlength="5" required>
                                <i class="bx bx-calendar"></i>
                            </div>
                        </div>
                        
                        <div class="col-md-6 mb-3">
                            <label class="form-label">CVV <span class="text-danger">*</span></label>
                            <div class="customField">
                                <input type="text" [(ngModel)]="paymentData.cardCode" name="cardCode" 
                                    class="form-control" placeholder="123" maxlength="4" required>
                                <i class="bx bx-lock"></i>
                            </div>
                        </div>
                    </div>
                
                </form>
            </div>
        </div> -->
    </div>

    <!-- Right Column -->
    <div class="col-lg-5">
      <!-- Order Summary -->
      <div class="card sticky-top" style="top: 20px; z-index: 1;">
        <div class="card-body">
          <h2 class="card-title mb-4">Your Order</h2>
          
            <div *ngIf="!isLoading && cartItemsLength != 0" style="background-color: #FEAE1D;border-radius: 8px;padding: 10px;">
                <div *ngFor="let item of cartItems;let i = index;" class="position-relative pb-1" >
                    <a (click)="removeItem(i)" style="position: absolute;right: 0;"><i class="bx bx-trash"></i></a>
                    <div class="d-flex w-100 p-1">
                        <img [src]="item.avatar" [alt]="item.name" width="80" height="80" style="border-radius: 20px;" class="" alt="Product">
                        <div class="ps-2 w-100">
                            <h6 class="mb-1">{{item.name}}</h6>
                            <p class="small text-muted mb-1">{{item.components}}</p>
                            
                            <!-- Display Selected Extras -->
                            <div *ngIf="item.selectedExtraId && item.selectedExtraId.length > 0">
                                <p class="description mb-0">Extras: 
                                    <span class="mt-0" *ngFor="let extra of item.selectedExtraId; let last = last" style="color: #c71d1d;">
                                        {{ extra.name }}<span *ngIf="extra.quantity > 1"> ({{ extra.quantity }}x)</span><span *ngIf="!last">, </span>
                                    </span>
                                </p>
                            </div>
                            
                            <!-- Display Free Sides -->
                            <div *ngIf="item.selectedFreeSides && item.selectedFreeSides.length > 0">
                                <p class="description mb-0">Free Sides: 
                                    <span class="mt-0" *ngFor="let side of item.selectedFreeSides; let last = last" style="color: #c71d1d;">
                                        {{ side.name }}<span *ngIf="!last">, </span>
                                    </span>
                                </p>
                            </div>
                            
                            <div class="d-flex align-items-center" style="float: left;">
                                <span class="text-muted" *ngIf="item.offer" style="text-decoration: line-through; margin-right: 5px;">
                                    ${{getOriginalItemPrice(item) | number:'1.2-2'}}
                                </span>
                                <span class="text-muted" [class.text-danger]="item.offer">
                                    ${{getItemPrice(item) | number:'1.2-2'}}
                                </span>
                                <span *ngIf="item.offer" class="badge bg-danger ms-2" style="font-size: 10px;">
                                    {{getOfferText(item)}}
                                </span>
                                
                                <!-- Show item total (unit price * quantity) -->
                                <span class="text-muted ms-2" style="font-size: 0.9em;">
                                    × {{item.quantity}} = ${{getItemTotalPrice(item) | number:'1.2-2'}}
                                </span>
                            </div>
                            <span class="text-muted float-end">QTY: {{item.quantity}}</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="account-card text-center" *ngIf="isLoading">
                <div class="spinner-grow" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div class="alert alert-danger text-center" *ngIf="cartItemsLength === 0 && !isLoading">
                <div class="item-image">
                    <img src="../../../../assets/img/home2/empty-cart.png" width="200" alt="Empty Cart">
                </div>
                
                <div class="item-details">
                    <h3>Your cart is empty</h3>
                    <p class="description">You haven't added any items to your cart yet.</p>
                </div>
            </div>

            <div class="mt-3 deliveryTipsContainer">
                <p class="deliveryTipsTitle mb-3">Delivery Tips</p>
  
                <div class="deliveryTipsOptions">
                    <!-- Percentage Options -->
                    <div class="delivery-tip-option" 
                        *ngFor="let percent of tipPercentages" 
                        [class.active]="selectedTip === percent"
                        (click)="selectTip(percent)">
                        <input class="d-none" type="radio" name="deliveryTip" 
                                [id]="'tip-' + percent" [value]="percent" 
                                [(ngModel)]="selectedTip">
                        <label [for]="'tip-' + percent">{{percent}}%</label>
                    </div>
                </div>
  
                <!-- Custom Amount Option -->
                <div class="delivery-tip-option custom-option mt-2 mx-3" 
                    [class.active]="selectedTip === 'custom'"
                    (click)="selectCustomTip()">
                    <input class="d-none" type="radio" name="deliveryTip" 
                        id="tip-custom" value="custom" 
                        [(ngModel)]="selectedTip">
                    <label for="tip-custom">Other</label>
                    <input type="number" class="form-control custom-tip-input" 
                        *ngIf="selectedTip === 'custom'"
                        [(ngModel)]="customTipAmount" 
                        placeholder="Enter amount ($)"
                        (input)="calculateTotals()"
                        (click)="$event.stopPropagation()"
                        (focus)="selectCustomTip()"
                        min="0" step="0.01">
                </div>
  
                <!-- Reset Button -->
                <div class="text-end mt-2">
                    <button class="btn btn-sm btn-outline-dark" (click)="resetTips(); calculateTotals()">
                        <i class="bx bx-undo me-1"></i> Reset
                    </button>
                </div>
            </div>

            <div class="mt-3 deliveryMethodContainer">
                <p class="deliveryMethodTitle mb-3">Delivery Method</p>

                <div class="payment-option d-flex align-items-center">
                    <input type="radio" id="delivery" name="deliveryMethod" checked [(ngModel)]="deliveyOption" (click)="changeDeliveryMethod('delivery')" value="delivery">
                    <label style="font-size: 18px;" for="delivery">Delivery</label>
                </div>
                <div class="payment-option d-flex align-items-center">
                    <input type="radio" id="pickup" name="deliveryMethod" [(ngModel)]="deliveyOption" (click)="changeDeliveryMethod('pickup')" value="pickup">
                    <label style="font-size: 18px;" for="pickup">Pickup</label>
                </div>
                
                <small *ngIf="deliveyOption == 'pickup'" class="text-success">Please notice your mailbox to get your order details</small>
            </div>

            <!-- <div class="mt-3 deliveryTipsContainer" *ngIf="selectedTip">
                <p class="deliveryTipsTitle">Delivery Tips</p>
                <div class="d-flex deliveryTipsNumbers">
                    <span class="deliveryTipsNumber">{{selectedTip}}%</span>
                </div>
            </div> -->
          
            <div class="mt-4 pt-2" style="border-top: 1px solid #dee2e6;">
                <div class="d-flex justify-content-between mb-2">
                    <span>Product total</span>
                    <span>${{subtotalCart | number:'1.2-2'}}</span>
                </div>
                <div class="d-flex justify-content-between mb-2">
                    <span>Service Fee</span>
                    <span><span *ngIf="feeType == 'fixed'">$</span> <span *ngIf="feeType == 'percentage'">%</span> {{feeValue | number:'1.2-2'}}</span>
                </div>
                <div class="d-flex justify-content-between mb-2">
                    <span>Delivery fee</span>
                    <span *ngIf="delivery_fees == 0">Free</span>
                    <span *ngIf="delivery_fees > 0">${{delivery_fees | number:'1.2-2'}}</span>
                </div>
                <div class="d-flex justify-content-between mb-2">
                    <span>Tax</span>
                    <span><span *ngIf="taxType == 'fixed'">$ {{taxValue}}</span> <span *ngIf="taxType == 'percentage'">$ {{(taxValue * (subtotalCart + feeValue)) / 100 | number:'1.2-2'}}</span></span>
                </div>
                <div class="d-flex justify-content-between mb-2" *ngIf="selectedTip">
                    <span>Tips</span>
                    <span *ngIf="selectedTip != 'custom'">% {{selectedTip}} </span>
                    <span *ngIf="customTipAmount && selectedTip == 'custom'">$ {{customTipAmount | number:'1.2-2'}}</span>
                </div>
                <div class="d-flex justify-content-between mb-2 text-success" *ngIf="discountFromOffers > 0">
                    <span>Items Discount</span>
                    <span>-${{discountFromOffers | number:'1.2-2'}}</span>
                </div>

                <div class="d-flex justify-content-between mb-2 text-success" *ngIf="couponApplied">
                    <span *ngIf="couponType == 'percentage'">Coupon: ({{couponValue}}%)</span>
                    <span *ngIf="couponType == 'value'">Coupon: ({{couponValue}}$ off)</span>
                    <span>-${{discount | number:'1.2-2'}}</span>
                </div>

                <!-- <div class="d-flex justify-content-between mb-2 text-success" *ngIf="couponApplied">
                    <span *ngIf="couponType == 'percentage'">Coupon: ({{couponValue}}%)</span>
                    <span *ngIf="couponType == 'value'">Coupon: ({{couponValue}}$ off)</span>
                    <span>-${{discount | number:'1.2-2'}}</span>
                </div> -->
                
                <div class="d-flex justify-content-between mt-3 pt-3 border-top fw-bold fs-5" style="color: #FEAE1D;">
                    <span>Total</span>
                    <span>${{totalCart | number:'1.2-2'}}</span>
                </div>
                
                <button *ngIf="!isGuestMode" class="btn btn-primary w-100 mt-4 py-3 text-center" [disabled]="isLoadingPlaceOrder" (click)="placeOrder()"> <!--submitPayment()-->
                    <span *ngIf="isLoadingPlaceOrder" class="spinner-border spinner-border-sm me-1"></span>
                    Place Order
                </button>

                <button *ngIf="isGuestMode" class="btn btn-primary w-100 mt-4 py-3 text-center" [disabled]="isLoadingPlaceOrder" (click)="placeOrderWithoutToken()"> <!--submitPaymentAsGuest() placeOrder()-->
                    <span *ngIf="isLoadingPlaceOrder" class="spinner-border spinner-border-sm me-1"></span>
                    Place Order
                </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer-style-two></app-footer-style-two>


<!-- <div *ngIf="!isLoading && cartItemsLength != 0" style="background-color: #FEAE1D;border-radius: 8px;padding: 10px;">
                <div *ngFor="let item of cartItems" class=" pb-1" >
                    <div class="d-flex w-100 p-1">
                        <img [src]="item.avatar" [alt]="item.name" width="80" height="80" style="border-radius: 20px;" class="" alt="Product">
                        <div class="ps-2 w-100">
                            <h6 class="mb-1">{{item.name}}</h6>
                            <p class="small text-muted mb-1">{{item.components}}</p>
                            <div *ngIf="item.selectedExtraId && item.selectedExtraId.length > 0">
                                <p class="description mb-0">Extras: 
                                    <span class="mt-0" *ngFor="let extra of getUniqueExtrasWithCount(item); let last = last" style="color: #c71d1d;">
                                        {{ extra.name }}<span *ngIf="extra.count > 1"> ({{ extra.count }}x)</span><span *ngIf="!last">, </span>
                                    </span>
                                </p>
                            </div>
                            <div *ngIf="item.selectedFreeSides && item.selectedFreeSides.length > 0">
                                <p class="description mb-0">Free Sides: 
                                    <span class="mt-0" *ngFor="let side of item.selectedFreeSides; let last = last" style="color: #28a745;">
                                        {{ side.name }}<span *ngIf="!last">, </span>
                                    </span>
                                </p>
                            </div>
                            <div class="d-flex align-items-center" style="float: left;">
                                <span class="text-muted" *ngIf="item.offer" style="text-decoration: line-through; margin-right: 5px;">
                                    ${{getOriginalItemPrice(item) | number:'1.2-2'}}
                                </span>
                                <span class="text-muted" [class.text-danger]="item.offer">
                                    ${{getItemPrice(item) | number:'1.2-2'}}
                                </span>
                                <span *ngIf="item.offer" class="badge bg-danger ms-2" style="font-size: 10px;">
                                    {{getOfferText(item)}}
                                </span>
                                
                                <span class="text-muted ms-2" style="font-size: 0.9em;">
                                    × {{item.quantity}} = ${{getItemTotalPrice(item) | number:'1.2-2'}}
                                </span>
                            </div>
                            <span class="text-muted float-end">QTY: {{item.quantity}}</span>
                        </div>
                    </div>
                </div>
            </div> -->